import { Store } from '@nextforce/api'
import { Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { View } from 'react-native'
import SearchBar from 'shared/components/search_bar'

export function StoreSearchBar({
  filteredStores,
  setSearchEnabled,
  setSearchTerm,
  searchTerm,
}: {
  filteredStores?: Store[] | undefined
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  setSearchEnabled: React.Dispatch<React.SetStateAction<boolean>>
  searchTerm: string
}) {
  const styles = useStyles()
  return (
    <View style={styles.card}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text style={styles.listHeaderText}>{t('filteredStores')}</Text>
        <View style={styles.storeCountContainer}>
          <Text style={styles.filteredStoreCountText}>
            {filteredStores?.length ?? 0}
          </Text>
        </View>
      </View>
      <View style={styles.searchBar}>
        <SearchBar
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          onPressClear={() => {
            setSearchEnabled(false)
            setSearchTerm('')
          }}
        />
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: theme.colors.white,
    width: '100%',
    marginBottom: 2,
    padding: 10,
  },
  text: {
    marginTop: 2,
    fontSize: 16,
  },
  searchInputContainer: { paddingHorizontal: 0 },
  storeCountContainer: {
    margin: 5,
    padding: 5,
    backgroundColor: theme.colors.peach,
    borderRadius: 50,
  },
  filteredStoreCountText: {
    fontSize: 14,
    paddingHorizontal: 10,
    color: 'black',
  },
  listHeaderText: { fontSize: 16, marginRight: 5 },
  searchBar: {
    flexDirection: 'row',
    backgroundColor: theme.colors.white,
  },
}))
